import { uid } from '../../../../lib/uid';

/**
 * Test-data generator backing the Autogenerate button on the create-user form.
 *
 * Fills every required field so the primary action enables on the first try. Keep this in
 * lockstep with the form: a new required field must be added here in the same change, or
 * Autogenerate silently stops working.
 *
 * Values are synthetic. Never put a real person's name, a real address, or a real contact
 * number in here — this is sample data, not a fixture drawn from production.
 */

const HANDLES = ['alex', 'sam', 'jordan', 'riley', 'casey', 'morgan', 'avery', 'quinn'];

function pick<T>(values: readonly T[]): T {
  return values[Math.floor(Math.random() * values.length)];
}

export interface SampleUser {
  alias: string;
  email: string;
}

export function sampleUser(): SampleUser {
  const handle = pick(HANDLES);

  // The uid suffix keeps repeated clicks from colliding on the unique email constraint.
  const suffix = uid().slice(0, 6).toLowerCase();

  return {
    alias: `${handle}.${suffix}`,
    email: `${handle}.${suffix}@example.test`,
  };
}
